// extracted by css-extract-rspack-plugin
export default {"header":"header-FpmjxN","backButton":"backButton-p3ciJs","backIcon":"backIcon-MeD8LH","segmentLabel":"segmentLabel-pNrwri"};